import script from "./WindTagDevicesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WindTagDevicesTable.vue?vue&type=script&setup=true&lang=js"

import "./WindTagDevicesTable.vue?vue&type=style&index=0&id=574426dd&lang=css"

const __exports__ = script;

export default __exports__